module.exports = __webpack_public_path__ + "static/your-customer-db292446da39e3d75771a958fd7949fb.png";